import { render } from "./Prediction.vue?vue&type=template&id=0c526c86&scoped=true&ts=true"
import script from "./Prediction.vue?vue&type=script&lang=ts"
export * from "./Prediction.vue?vue&type=script&lang=ts"

import "./Prediction.vue?vue&type=style&index=0&id=0c526c86&lang=scss&scoped=true"
import "./Prediction.vue?vue&type=style&index=1&id=0c526c86&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c526c86"]])

export default __exports__